import {
  request
} from '@/utils/request.js'

const addPlayer = (data, callback, errCallback, finCallback) => {
  request({
    url: '/org/players',
    method: 'POST',
    data: data,
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}

const editPlayer = (id, data, callback, errCallback, finCallback) => {
  request({
    url: '/org/players/' + id,
    method: 'PUT',
    data: data,
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}

const getPlayers = (data, callback, errCallback, finCallback) => {
  request({
    url: '/org/players',
    method: 'GET',
    params: data,
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}

const getOrgs = (callback, errCallback, finCallback) => {
  request({
    url: '/org/organizations',
    method: 'GET',
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}

const movePlayerToOrg = (organizationId, playerId, callback, errCallback, finCallback) => {
  request({
    url: `/org/players/${organizationId}/${playerId}`,
    method: 'PUT',
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}

const deletePlayer = (id, callback, errCallback, finCallback) => {
  request({
    url: '/org/players/' + id,
    method: 'DELETE',
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}

export {
  addPlayer,
  editPlayer,
  getPlayers,
  getOrgs,
  movePlayerToOrg,
  deletePlayer
}


// WEBPACK FOOTER //
// ./src/servers/org.js